import { render, staticRenderFns } from "./LoaderWithTitle.vue?vue&type=template&id=8d44f2c2"
import script from "./LoaderWithTitle.vue?vue&type=script&lang=js"
export * from "./LoaderWithTitle.vue?vue&type=script&lang=js"
import style0 from "./LoaderWithTitle.vue?vue&type=style&index=0&id=8d44f2c2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports